import { render, staticRenderFns } from "./ed-list-homework.vue?vue&type=template&id=42318acc&scoped=true&"
import script from "./ed-list-homework.ts?vue&type=script&lang=ts&"
export * from "./ed-list-homework.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-homework.scss?vue&type=style&index=0&id=42318acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42318acc",
  null
  
)

export default component.exports